import React, { useContext } from "react";
import styled from "styled-components";
import basketContext from "../../../context/BasketContext";
import BasketLine from "../../molecules/BasketLine/BasketLine";
import { Link } from "react-router-dom";
import { PRIMARY } from "../../../vars/vars";

const BasketCart = ({ updateHandler, deleteHandler, isLoading }) => {
  const ctx = useContext(basketContext);

  return (
    <Component>
      <StyledTable>
        <TableHeader>Przedmiot</TableHeader>
        <TableHeader>Cena</TableHeader>
        <TableHeader>Ilość</TableHeader>
        <TableHeader>Suma częściowa</TableHeader>
        {ctx.basket &&
          ctx.basket.transactionlines.map((item) => (
            <BasketLine
              isLoading={isLoading}
              deleteHandler={deleteHandler}
              changeHanlder={updateHandler}
              key={item._id}
              item={item}
              basketId={ctx.basketId}
              currency={ctx.basket.currency.symbol}
            />
          ))}
      </StyledTable>
      {!!ctx.basket.backorderquantity && (
        <StyledBackorderInfo>
          <p>
            *Ponieważ co najmniej jeden z produktów ma wydłużony czas
            realizacji, całe zamówienie zostanie zrealizowane po skompletowaniu.
          </p>
        </StyledBackorderInfo>
      )}
      <Continue to={"/"}>Kontynuuj zakupy</Continue>
    </Component>
  );
};

export default BasketCart;

const Component = styled.section`
  grid-area: basket;
`;

const Continue = styled(Link)`
  display: inline-block;
  font-weight: 500;
  border-radius: 0;
  height: 36px;
  margin-top: 20px;
  line-height: 36px;
  font-size: 12px;
  font-family: "Open Sans", sans-serif;
  color: white;
  background-color: ${PRIMARY};
  text-transform: uppercase;
  padding: 0 20px;

  &:hover {
    background-color: #444444;
    color: white;
  }
`;

const StyledTable = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 1fr;
`;

const TableHeader = styled.div`
  color: #666666;
  font-size: 12px;
  border-bottom: 2px solid #dee2e6;
  border-top: 1px solid #dee2e6;
  text-transform: uppercase;
  padding-top: 20px;
  padding-bottom: 10px;
  font-weight: 700;
  &:not(:first-of-type) {
    text-align: right;
  }
`;

const StyledBackorderInfo = styled.div`
  margin: 20px 0;
  font-size: 14px;
`;
